import { Component, OnInit, TemplateRef, ChangeDetectorRef, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MatDialog } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { FormsService } from '../eSignature/services/forms.service';
import { DatePipe } from '@angular/common'
import { Observable, Subscription } from 'rxjs';
import {
  ChartComponent, ApexAxisChartSeries, ApexChart, ApexXAxis, ApexDataLabels,
  ApexTooltip, ApexStroke, ApexNonAxisChartSeries, ApexResponsive, ApexFill, ApexMarkers
} from "ng-apexcharts";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { SettingService } from '../settings/services/settingService/setting.service';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { SelectFormIconComponent } from 'src/app/middleware/common/selectFormIcon/selectFormIcon.component';
import { MatRadioChange } from '@angular/material/radio';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { map, startWith } from 'rxjs/operators';


@Component({
  selector: 'app-residentdashboard',
  templateUrl: './residentdashboard.component.html',
  styleUrls: ['./residentdashboard.component.scss'],
})
export class ResidentDashboardComponent implements OnInit {



  constructor() { 
    
  }

 
  ngOnInit(): void {   
   
  }

      

 }
